<div class="code-container">
  <pre class="flex-grow-1">{{ code }}</pre>
  <button
    mat-icon-button
    class="copy-icon-btn"
    (click)="copy()"
    i18n-matTooltip
    matTooltip="Copy"
  >
    <mat-icon>content_copy</mat-icon>
  </button>
</div>
